// extracted by mini-css-extract-plugin
module.exports = {"container":"AllDeals_container__3LhE4","title":"AllDeals_title__2LWem","dealsContainer":"AllDeals_dealsContainer__27T0j","rtl":"AllDeals_rtl__29PZi"};